import { ComponentType } from 'react'
import { AboutNav } from 'views/common/about-nav'
import { TextHero } from 'components/TextHero'
import { Listing } from './listing'

export const Testimonials: ComponentType = () => (
  <>
    <TextHero title="Conoce Mérida, Descubre Yucatán" subtitle="Una experiencia premier" />
    <AboutNav />
    <Listing />
  </>
)
